import { accountLedger, acctKey, ledger } from '@khata/core';
import { Empty, MonthPicker, Row, ShowMore } from '../components/index.js';
import { usePaged } from '../lib/paging.js';
import { taka } from '../lib/format.js';
import { t } from '../lib/i18n.js';
import { entries, master, state, today } from '../lib/khata.js';
import { accountKind } from '../lib/labels.js';
import { monthsWithEntries, periodRange } from '../lib/lists.js';
import { inRange } from '@khata/core';
import { describe } from '../lib/labels.js';
import { go } from '../lib/router.js';
import { listPeriod, openSheet } from '../lib/ui.js';

/** Statement of one cash or bank account: every movement with a running balance. */
export function AccountLedger(props: { id: string }) {
  const s = state.value;
  const m = master.value;
  const account = m.accounts.get(props.id);
  if (!account) {
    return (
      <>
        <button type="button" class="btn btn-ghost" onClick={() => go('bank')}>
          {t('ledger_back')}
        </button>
        <Empty>{t('ledger_missing')}</Empty>
      </>
    );
  }
  const balance = ledger(s, acctKey(account.id));
  const range = periodRange(listPeriod.value, today.value);
  const rows = accountLedger(s, entries.value, account.id)
    .filter((r) => inRange(r.entry.date, range))
    .reverse();
  const paged = usePaged(rows, 100);

  return (
    <>
      <button
        type="button"
        class="btn btn-ghost"
        style={{ marginLeft: -5, marginBottom: 8 }}
        onClick={() => go('bank')}
      >
        {t('ledger_back')}
      </button>
      <header style={{ marginBottom: 20 }}>
        <div class="page-kicker">
          {accountKind(account.kind)}
          {account.active ? '' : ' · ' + t('bank_closed')}
        </div>
        <h1 class="page-title" style={{ fontSize: 32, margin: '4px 0 6px' }}>
          {account.name}
        </h1>
        <div class="small muted">{t('ledger_balance')}</div>
        <div
          class={'kpi-value ' + (balance < 0 ? 'bad' : 'ink')}
          style={{ fontSize: 30 }}
          data-testid="ledger-balance"
        >
          {taka(balance)}
        </div>
      </header>
      <div class="actions" style={{ marginBottom: 30 }}>
        <button
          type="button"
          class="btn btn-primary"
          onClick={() => openSheet({ kind: 'transfer' })}
        >
          {t('bank_transfer')}
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          onClick={() => openSheet({ kind: 'account', id: account.id })}
        >
          {t('edit')}
        </button>
      </div>
      <h6 class="section">{t('ledger_title')}</h6>
      <MonthPicker months={monthsWithEntries(entries.value)} />
      <div class="list" data-testid="ledger-rows">
        {rows.length === 0 && <Empty>{t('ledger_empty')}</Empty>}
        {paged.visible.map((r) => {
          const l = describe(m, r.entry);
          return (
            <Row
              key={r.entry.id}
              title={l.title}
              sub={l.sub}
              amount={r.voided ? t('voided') : (r.delta > 0 ? '+' : '') + taka(r.delta)}
              amountTone={r.voided ? 'muted' : r.delta > 0 ? 'good' : 'ink'}
              amountSub={`${t('party_bal')} ${taka(r.running)}`}
              strike={r.voided}
              onClick={() => openSheet({ kind: 'entry', id: r.entry.id })}
            />
          );
        })}
      </div>
      <ShowMore shown={paged.shown} total={paged.total} onMore={paged.more} />
    </>
  );
}
